export default __webpack_public_path__ + "static/media/DoubleRing.f1b98600.svg";